import { render } from "./Signup.vue?vue&type=template&id=8ab35a40&scoped=true&lang=pug"
import script from "./Signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Signup.vue?vue&type=script&setup=true&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=8ab35a40&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab35a40"]])

export default __exports__